import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../app/providers/AuthProvider";
import FeatureGuard from "../../capabilities/FeatureGuard";
import { FK } from "../../capabilities/featureKeys";
import TeamStaffPage from "./TeamStaffPage";
import RolePermissionMapping from "../Settings/AccessControl/RolePermissionMapping";

const teamPath = "/app/settings/team-management";

function tabLocation(location, tab) {
  const query = new URLSearchParams(location.search);
  query.set("tab", tab);
  return { pathname: teamPath, search: `?${query}`, hash: location.hash };
}

export function LegacyRolePermissionsRedirect() {
  const location = useLocation();
  return <Navigate to={tabLocation(location, "roles")} replace />;
}

function TeamManagementContent() {
  const location = useLocation();
  const { can, hasAllAccess } = useAuth();
  const tab = new URLSearchParams(location.search).get("tab");
  if (tab !== "members" && tab !== "roles") {
    const initialTab = hasAllAccess || can?.(FK.SETTINGS_STAFF_MANAGEMENT) ? "members" : "roles";
    return <Navigate to={tabLocation(location, initialTab)} replace />;
  }
  return <FeatureGuard code={tab === "members" ? FK.SETTINGS_STAFF_MANAGEMENT : FK.SETTINGS_ROLE_PERMISSIONS_MAPPING}>
    {tab === "members" ? <TeamStaffPage /> : <RolePermissionMapping />}
  </FeatureGuard>;
}

export default function TeamManagementPage() {
  return <FeatureGuard codes={[FK.SETTINGS_STAFF_MANAGEMENT, FK.SETTINGS_ROLE_PERMISSIONS_MAPPING]}>
    <TeamManagementContent />
  </FeatureGuard>;
}
